export const DEFAULTS = {
  config: {
    enableEmbed: false,
  },
};
